import AccountMutations from "./AccountMutations";
import AccountActions from "./AccountActions";
import AccountGetters from "./AccountGetters";

import TokenService from "@/services/common/auth/TokenService";

const state = { token: TokenService.GetSessionCookie() || "" };

const { actions } = AccountActions;

const { mutations } = AccountMutations;

const { getters } = AccountGetters;

const namespaced = true;

export default {
	namespaced, state, actions, getters, mutations,
};
